module.exports = __webpack_public_path__ + "static/img/ag_4.4e5bbdd.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント/ag_4.png
// module id = 871
// module chunks = 1